export const RUSSIAN_LETTERS_REG_EXP = /^[А-Яа-яЁё\s]+$/;
export const RUSSIAN_AND_ENGLISH_LETTERS_REG_EXP = /^[A-Za-zА-Яа-яЁё\s]+$/;
export const NUMBERS_REG_EXP = /^[0-9]+$/;

export const SECTIONS_IDS = {
    About: 'about',
    CalculateOnline: 'calculateOnline',
    HowItWorks: 'howItWorks',
    terms: 'terms',
    advantages: 'advantages',
    faq: 'faq',
} as const;

export const IS_DEV_MODE = process.env.NODE_ENV === 'development';

export const IS_TEST = window.location.href.includes('test');

export const TIME_SELECT_DATA = [
    { label: '10:00 - 12:00', value: '1', disabled: false },
    { label: '12:00 - 14:00', value: '2', disabled: false },
    { label: '14:00 - 16:00', value: '3', disabled: false },
    { label: '16:00 - 18:00', value: '4', disabled: false },
];

export const TODAY = new Date();

export const TODAY_PLUS_TWO_MONTHS = new Date(TODAY);

TODAY_PLUS_TWO_MONTHS.setMonth(TODAY.getMonth() + 2);

export const EMPTY_PHOTO_BASE64 = 'data:image/png;base64,';
